/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace text in bulk`)
};

const es_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplaza texto en lote`)
};

const de_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text massenhaft ersetzen`)
};

const nl_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst bulksgewijs vervangen`)
};

const fr_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacer le texte en masse`)
};

const it_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituisci il testo in massa`)
};

const pt_br2_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua texto em lote`)
};

const pt_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substitua texto em massa`)
};

const ja_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを一括置換`)
};

const zh_fr_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量替换文本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_nav_main_desc", locale)
	if (locale === "en") return en_fr_nav_main_desc(inputs)
	if (locale === "es") return es_fr_nav_main_desc(inputs)
	if (locale === "de") return de_fr_nav_main_desc(inputs)
	if (locale === "nl") return nl_fr_nav_main_desc(inputs)
	if (locale === "fr") return fr_fr_nav_main_desc(inputs)
	if (locale === "it") return it_fr_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_fr_nav_main_desc(inputs)
	if (locale === "pt") return pt_fr_nav_main_desc(inputs)
	if (locale === "ja") return ja_fr_nav_main_desc(inputs)
	return zh_fr_nav_main_desc(inputs)
};